import { LocalStorageKeys } from '@constants/enums';

export const RETURN_URL_KEY = `${LocalStorageKeys.ONBOARDING_PROCESS_DATA}_return_url`;
export const RETURN_URL_ATTEMPTS_KEY = `efex_return_url_attempts`;
export const MAX_REDIRECT_ATTEMPTS = 1;
export const TIMER_DELAY = 1000;

export const FORBIDDEN_ROUTES = [
  '/',
  '/login',
  '/register',
  '/reset',
  '/password',
  '/under-revision',
];

export const PROBLEMATIC_ROUTES = [
  '/validate-account',
  '/inactive',
  '/terms-and-conditions',
  '/transactional-profile',
];
